/**
 * Closes a quick buy modal after a successful add to cart, when the modal has the
 * `close-on-add` attribute (used by the cart drawer upsell).
 *
 * The modal is moved to <body> while open, so it is not removed when the cart
 * drawer re-renders and would otherwise stay on top of the drawer.
 */
(() => {
  if (window.__cleanrQuickBuyCloseOnAdd) return;
  window.__cleanrQuickBuyCloseOnAdd = true;

  document.addEventListener('variant:add', (event) => {
    const modal = event.target.closest?.('quick-buy-modal[close-on-add]');
    modal?.hide();
  });
})();
